import React, { Component } from 'react';
import { translate } from 'react-polyglot';

import Link from '../Link';
import SvgIcon from '../SvgIcon';

@translate()
class LoginDropdown extends Component {

  render() {
    const {
      t,
      LoginText,
      onClickLogin,
    } = this.props;
    const loginDropdown = (
      <div>
        <Link fullWidth legend={LoginText} onClick={onClickLogin}>
          <SvgIcon name="user" title={t('SvgTitle.user')}/> {t('global.log-in')}
        </Link>
        <Link fullWidth legend={LoginText} onClick={onClickLogin}>
          <SvgIcon name="user" title={t('SvgTitle.user')}/> {t('global.sign-up')}
        </Link>
      </div>
    );
    return loginDropdown
  }
}

export default LoginDropdown;



// WEBPACK FOOTER //
// ./src/components/LoginDropdown/LoginDropdown.jsx